import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { TranslatePipe } from '../../pipes/trans.pipe';
import { FormControlComponent } from '../form-control/form-control.component';
import { FormsModule } from '@angular/forms';
import { heightDirective } from '../../directives/height.directive';
import { BaseModalComponent } from '../../../core/layout/components/abstracts/base-modal.component';

@Component({
  selector: 'app-description-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    FormControlComponent,
    FormsModule,
    heightDirective
  ],
  templateUrl: './description-modal.component.html',
  styleUrl: './description-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DescriptionModalComponent extends BaseModalComponent<{ modalType?: 'cancel' | 'freeEntry'; }> {

  @Output() confirm = new EventEmitter<{ description: string; }>();

  public description: string;

  public override open(val?: { modalType?: 'cancel' | 'freeEntry'; }): void {
    this.description = null;
    super.open(val);
  }
}
